<div [ngClass]="[this.isDarkMode ? 'confirmation-dialog-dark' : 'confirmation-dialog-light', 'confirmation-dialog']">
  <h6>{{data.title | translate}}</h6>
  <p>{{data.message | translate}}</p>
  <div class="button-container">
    <button mat-button [ngStyle]="{'color': this.proColor, 'text-transform': 'uppercase'}" (click)="cancel()">{{ data.cancelText | translate}}</button>
    <button mat-button [ngStyle]="{'background-color': this.proColor , 'text-transform': 'uppercase'}" class="confirm-button" (click)="confirm()">{{data.confirmText | translate}}</button>
  </div>
</div>
